import { z } from "zod/v4";

import { ShopifyCurrencyList } from "../schemas/shopify";
import { castToString } from "../utils";

import {
  ShippingLineItemDtoSchema,
  ShippingLocationDtoSchema,
} from "./shipping-profile";
import { ShippingRateConditionDtoSchema } from "./shipping-rate-conditions";

export const ShopifyShippingRateOrderTotalsSchema = z.object({
  subtotal_price: castToString,
  total_price: castToString,
  discount_amount: castToString,
});

export const ShopifyShippingRateCustomerSchema = z
  .object({
    id: z.number().nullish(),
    tags: z.array(z.string()).nullish(),
  })
  .catchall(z.any());

export type ShopifyShippingRateCustomer = z.infer<
  typeof ShopifyShippingRateCustomerSchema
>;

export const ShopifyShippingRateDtoSchema = z.object({
  origin: ShippingLocationDtoSchema,
  destination: ShippingLocationDtoSchema,
  items: ShippingLineItemDtoSchema.array(),
  currency: z.string(),
  locale: z.string(),
  order_totals: ShopifyShippingRateOrderTotalsSchema.optional(),
  customer: ShopifyShippingRateCustomerSchema.nullish(),
});

export type ShopifyShippingRateDto = z.infer<
  typeof ShopifyShippingRateDtoSchema
>;

export const RateTypeList = ["amount", "threshold", "tier"] as const;
export type RateType = (typeof RateTypeList)[number];

export const ShippingRateDtoSchema = z.object({
  id: z.uuid().optional(),
  name: z.string(),
  amount: z.coerce.number(),
  rateCode: z.string().nullish(),
  rateType: z.enum(RateTypeList), // rate type?
  currency: z.enum(ShopifyCurrencyList), // we could type this
  condition: ShippingRateConditionDtoSchema.optional().nullish(),
  description: z.string().nullish(),
});
export type ShippingRateDto = z.infer<typeof ShippingRateDtoSchema>;
